"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _remoteVideoSourcesDidChangeHandler = require("./remoteVideoSourcesDidChangeHandler");
Object.keys(_remoteVideoSourcesDidChangeHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _remoteVideoSourcesDidChangeHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _remoteVideoSourcesDidChangeHandler[key];
    }
  });
});